// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  HandlerBaseResponse,
  HandlerErrorResponse,
  HandlerOperationAbortRequest,
  HandlerOperationListResponse,
  HandlerOperationResponse,
  HandlerOperationTriggerRequest,
  OperationscatalogOperation,
} from '../models/index';
import {
  HandlerBaseResponseFromJSON,
  HandlerBaseResponseToJSON,
  HandlerErrorResponseFromJSON,
  HandlerErrorResponseToJSON,
  HandlerOperationAbortRequestFromJSON,
  HandlerOperationAbortRequestToJSON,
  HandlerOperationListResponseFromJSON,
  HandlerOperationListResponseToJSON,
  HandlerOperationResponseFromJSON,
  HandlerOperationResponseToJSON,
  HandlerOperationTriggerRequestFromJSON,
  HandlerOperationTriggerRequestToJSON,
  OperationscatalogOperationFromJSON,
  OperationscatalogOperationToJSON,
} from '../models/index';

export interface V1AvailableOperationsGetRequest {
  pretty?: boolean;
  orchestra?: string;
  dbmsClusterId?: string;
}

export interface V1OperationsAbortPostRequest {
  body: HandlerOperationAbortRequest;
}

export interface V1OperationsGetRequest {
  limit?: number;
  databaseId?: string;
  dbmsClusterId?: string;
  serverId?: string;
  operationType?: string;
  requestedBy?: string;
  pretty?: boolean;
}

export interface V1OperationsIdGetRequest {
  id: string;
}

export interface V1OperationsPostRequest {
  body: HandlerOperationTriggerRequest;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
  /**
   * Ensure the API and database connection is active and healthy.
   * API and database Health Check
   */
  async pingGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/ping`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Ensure the API and database connection is active and healthy.
   * API and database Health Check
   */
  async pingGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.pingGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Returns a JSON array of Aura Operations from orchestra-notproductionlike/aura-operations. Each entry includes execution details and WorkflowTemplate-authored content, severity, warnings, and additional input fields. Caller must be a @neo4j.com address in TeamNewAuraOperations.
   * list available operations
   */
  async v1AvailableOperationsGetRaw(
    requestParameters: V1AvailableOperationsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<OperationscatalogOperation>>> {
    const queryParameters: any = {};

    if (requestParameters['pretty'] != null) {
      queryParameters['pretty'] = requestParameters['pretty'];
    }

    if (requestParameters['orchestra'] != null) {
      queryParameters['orchestra'] = requestParameters['orchestra'];
    }

    if (requestParameters['dbmsClusterId'] != null) {
      queryParameters['dbms_cluster_id'] = requestParameters['dbmsClusterId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/available-operations`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(OperationscatalogOperationFromJSON),
    );
  }

  /**
   * Returns a JSON array of Aura Operations from orchestra-notproductionlike/aura-operations. Each entry includes execution details and WorkflowTemplate-authored content, severity, warnings, and additional input fields. Caller must be a @neo4j.com address in TeamNewAuraOperations.
   * list available operations
   */
  async v1AvailableOperationsGet(
    requestParameters: V1AvailableOperationsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<OperationscatalogOperation>> {
    const response = await this.v1AvailableOperationsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * abort operation
   * abort operation
   */
  async v1OperationsAbortPostRaw(
    requestParameters: V1OperationsAbortPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlerBaseResponse>> {
    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling v1OperationsAbortPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/operations/abort`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: HandlerOperationAbortRequestToJSON(requestParameters['body']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlerBaseResponseFromJSON(jsonValue),
    );
  }

  /**
   * abort operation
   * abort operation
   */
  async v1OperationsAbortPost(
    requestParameters: V1OperationsAbortPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlerBaseResponse> {
    const response = await this.v1OperationsAbortPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * list operations
   * list operations
   */
  async v1OperationsGetRaw(
    requestParameters: V1OperationsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlerOperationListResponse>> {
    const queryParameters: any = {};

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['databaseId'] != null) {
      queryParameters['database_id'] = requestParameters['databaseId'];
    }

    if (requestParameters['dbmsClusterId'] != null) {
      queryParameters['dbms_cluster_id'] = requestParameters['dbmsClusterId'];
    }

    if (requestParameters['serverId'] != null) {
      queryParameters['server_id'] = requestParameters['serverId'];
    }

    if (requestParameters['operationType'] != null) {
      queryParameters['operation_type'] = requestParameters['operationType'];
    }

    if (requestParameters['requestedBy'] != null) {
      queryParameters['requested_by'] = requestParameters['requestedBy'];
    }

    if (requestParameters['pretty'] != null) {
      queryParameters['pretty'] = requestParameters['pretty'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/operations`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlerOperationListResponseFromJSON(jsonValue),
    );
  }

  /**
   * list operations
   * list operations
   */
  async v1OperationsGet(
    requestParameters: V1OperationsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlerOperationListResponse> {
    const response = await this.v1OperationsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * get operation by id
   * get operation by id
   */
  async v1OperationsIdGetRaw(
    requestParameters: V1OperationsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlerOperationResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1OperationsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/operations/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlerOperationResponseFromJSON(jsonValue),
    );
  }

  /**
   * get operation by id
   * get operation by id
   */
  async v1OperationsIdGet(
    requestParameters: V1OperationsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlerOperationResponse> {
    const response = await this.v1OperationsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * trigger operation (Argo workflow by default; operations with the db-manager-lookup kind execute synchronously and return a terminal status) Authentication is determined by the operation subject and is therefore not enforced at the API level.
   * trigger operation
   */
  async v1OperationsPostRaw(
    requestParameters: V1OperationsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlerOperationResponse>> {
    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling v1OperationsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/operations`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: HandlerOperationTriggerRequestToJSON(requestParameters['body']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlerOperationResponseFromJSON(jsonValue),
    );
  }

  /**
   * trigger operation (Argo workflow by default; operations with the db-manager-lookup kind execute synchronously and return a terminal status) Authentication is determined by the operation subject and is therefore not enforced at the API level.
   * trigger operation
   */
  async v1OperationsPost(
    requestParameters: V1OperationsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlerOperationResponse> {
    const response = await this.v1OperationsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
